import { h } from 'preact';

export const Section = ({
    content = '',
    description = '',
    thumbnail,
    styles = {}
}) => (
    <div className="quiz-section-details" data-has-thumbnail={thumbnail ? 'true' : 'false'}>
        <img src={thumbnail}/>
        <h1 style={styles.title}>{content}</h1>
        <p style={styles.description}>{description}</p>
    </div>
)